import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './AtlasLogoWithError.styles';

type AtlasLogoWithErrorIconProps = WithStyles<typeof styles>;

const AtlasLogoWithErrorIconComponent: FC<AtlasLogoWithErrorIconProps> = () => {
  return (
    <svg width="60" height="52" viewBox="0 0 60 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.886719" width="48" height="48" rx="12" fill="#9764D6" />
      <path
        d="M25.0176 35.4502C26.4738 35.4502 27.6541 36.6308 27.6543 38.0869C27.6543 39.5432 26.4739 40.7246 25.0176 40.7246C23.5613 40.7245 22.3809 39.5432 22.3809 38.0869C22.3811 36.6308 23.5615 35.4503 25.0176 35.4502ZM28.2568 28.7334L36.584 36.1338C35.1972 37.442 33.5879 38.5181 31.8203 39.2969L25.0127 32.1426L18.2109 39.293C16.4433 38.5142 14.8341 37.4381 13.4473 36.1299L21.7695 28.7354L25.0146 25.8525L28.2568 28.7334ZM20.1436 20.6172L23.0264 23.8623L20.1455 27.1035L12.7451 35.4316C11.4369 34.0449 10.3608 32.4356 9.58203 30.668L16.7363 23.8604L9.58496 17.0576C10.3638 15.2899 11.4398 13.6808 12.748 12.2939L20.1436 20.6172ZM37.2822 12.2939C38.5905 13.6808 39.6665 15.2899 40.4453 17.0576L33.2939 23.8604L40.4482 30.668C39.6694 32.4356 38.5934 34.0449 37.2852 35.4316L29.8848 27.1035L27.0039 23.8623L29.8867 20.6172L37.2822 12.2939ZM10.7891 21.2285C12.2453 21.2285 13.4257 22.409 13.4258 23.8652C13.4258 25.3216 12.2454 26.502 10.7891 26.502C9.33282 26.5019 8.15234 25.3215 8.15234 23.8652C8.15241 22.409 9.33286 21.2286 10.7891 21.2285ZM39.2383 21.2285C40.6946 21.2285 41.8749 22.409 41.875 23.8652C41.875 25.3216 40.6946 26.502 39.2383 26.502C37.782 26.5018 36.6016 25.3215 36.6016 23.8652C36.6016 22.409 37.7821 21.2286 39.2383 21.2285ZM31.8203 8.42969C33.588 9.20849 35.1972 10.2845 36.584 11.5928L28.2568 18.9922L25.0146 21.874L21.7695 18.9912L13.4473 11.5957C14.8341 10.2875 16.4433 9.21141 18.2109 8.43262L25.0127 15.584L31.8203 8.42969ZM25.0176 7C26.4739 7 27.6552 8.18046 27.6553 9.63672C27.6553 11.093 26.4739 12.2734 25.0176 12.2734C23.5614 12.2733 22.3809 11.0929 22.3809 9.63672C22.3809 8.18056 23.5614 7.00016 25.0176 7Z"
        fill="white"
      />
      <circle cx="45.1523" cy="38" r="12.5" fill="#FFE4E0" stroke="white" strokeWidth="3" />
      <g clipPath="url(#clip0_4227_8928)">
        <path
          d="M45.153 35.3333V37.9999M45.153 40.6666H45.1597M51.8197 37.9999C51.8197 41.6818 48.8349 44.6666 45.153 44.6666C41.4711 44.6666 38.4863 41.6818 38.4863 37.9999C38.4863 34.318 41.4711 31.3333 45.153 31.3333C48.8349 31.3333 51.8197 34.318 51.8197 37.9999Z"
          stroke="#EA3418"
          strokeWidth="1.65"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4227_8928">
          <rect width="16" height="16" fill="white" transform="translate(37.1523 30)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AtlasLogoWithErrorIcon = withStyles(styles)(AtlasLogoWithErrorIconComponent);
